import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const defaultFill = 'currentColor';
const defaultSize = '1.11em';

const SvgIconBase = ({ children, inlineLeft, ...other }) => (
  <svg
    data-smc="Icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox=" 0 0 24 24"
    {...other}
  >
    {children}
  </svg>
);

SvgIconBase.propTypes = {
  children: PropTypes.node.isRequired,
  inlineLeft: PropTypes.bool,
};
SvgIconBase.defaultProps = {
  inlineLeft: false,
};

const SvgIcon = styled(SvgIconBase)`
  vertical-align: middle;
  width: ${(props) => props.size || defaultSize};
  height: ${(props) => props.size || defaultSize};
  fill: ${(props) => props.color || defaultFill};
  ${(props) => props.onClick && css`cursor: pointer;`};
  ${(props) => props.inlineLeft && css`margin-right: 10px;`};
`;


export default SvgIcon;
